import { gnrStateEnum } from '../enums';

export const gnrStateEnumColors: Record<number, { background: string; text: string }> = {
    [gnrStateEnum.REQUESTED]: { background: 'lightblue', text: 'black' },
    [gnrStateEnum.IN_PROGRESS]: { background: 'yellow', text: 'black' },
    [gnrStateEnum.DELIVERED]: { background: '#8BC34A', text: 'black' },
    [gnrStateEnum.CANCELED]: { background: 'gray', text: 'white' },
    [gnrStateEnum.ARCHIVED]: { background: '#616161', text: 'white' },
};

export const getGnrStateColor = (state?: number): string => {
    return state !== undefined ? (gnrStateEnumColors[state]?.background ?? '') : '';
};
